import { getToken } from "../utils/authUtils";
import { parseJSON } from "./parseJSON";
import { parseText } from "./parseText";

const urlBase = `${process.env.API_URL}/lab`;
const readUrlSimple = (url = "") => `${process.env.API_URL}${url}`;
const readUrl = (url = "") => `${urlBase}${url}`;

export const getCourses = async (params) => {
  const auth = `Bearer ${getToken()}`;

  const query = new URLSearchParams(params);

  // Obtén el valor del parámetro "sort"
  const sortParam = query.get("sort");
  if (sortParam) {
    // Agrega los nuevos parámetros "orderBy" y "orderType"

    query.set("orderBy", sortParam);
    query.set("orderType", "ASC");
  }
  // Verifica si el parámetro "sort" tiene un signo menos (-)
  if (sortParam && sortParam.startsWith("-")) {
    // Remueve el signo menos (-) y obtén el valor de "sort"
    const sortValue = sortParam.substring(1);

    // Agrega los nuevos parámetros "orderBy" y "orderType"
    query.set("orderBy", sortValue);
    query.set("orderType", "DESC");
  }
  query.delete("sort");

  let res = await fetch(readUrl(`/courses?${query.toString()}`), {
    method: "GET",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
  });

  res = await parseJSON(res);

  return res.success;
};

export const getCourseById = async (itemId) => {
  const auth = `Bearer ${getToken()}`;

  let res = await fetch(readUrl(`/course/${itemId}`), {
    method: "GET",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
  });
  res = await parseJSON(res);

  return res.success;
};
export const createCourse = async (courseData) => {
  const auth = `Bearer ${getToken()}`;

  try {
    let res = await fetch(readUrl(`/course`), {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: auth,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(courseData),
    });

    res = await parseJSON(res);

    return res.success;
  } catch (error) {
    return error;
  }
};

export const updateCourse = async (courseId, courseData) => {
  const auth = `Bearer ${getToken()}`;

  let res = await fetch(readUrl(`/course/${courseId}`), {
    method: "PATCH",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(courseData),
  });

  res = await parseJSON(res);

  return res.success;
};

export const deleteCourse = async (id) => {
  const auth = `Bearer ${getToken()}`;

  let res = await fetch(readUrl(`/course/${id}`), {
    method: "DELETE",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
  });

  res = await parseJSON(res);

  return res.success;
};

export const copyCourse = async (id) => {
  const auth = `Bearer ${getToken()}`;

  let res = await fetch(readUrl(`/course/copy/${id}`), {
    method: "POST",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
  });

  res = await parseJSON(res);

  return res.success;
};

export const getLabCategories = async () => {
  const auth = `Bearer ${getToken()}`;

  let res = await fetch(readUrl(`/categories`), {
    method: "GET",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
  });

  res = await parseJSON(res);

  return res.success;
};

// UNITS

export const createUnit = async (unitData) => {
  const auth = `Bearer ${getToken()}`;

  let res = await fetch(readUrl(`/unit`), {
    method: "POST",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(unitData),
  });

  res = await parseJSON(res);

  return res.success;
};

export const updateUnit = async (unitId, unitData) => {
  const auth = `Bearer ${getToken()}`;

  let res = await fetch(readUrl(`/unit/${unitId}`), {
    method: "PATCH",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(unitData),
  });

  res = await parseJSON(res);

  return res.success;
};

export const deleteUnit = async (id) => {
  const auth = `Bearer ${getToken()}`;

  let res = await fetch(readUrl(`/unit/${id}`), {
    method: "DELETE",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
  });

  res = await parseJSON(res);

  return res.success;
};

// COMPONENTS

export const createComponent = async (componentData) => {
  const auth = `Bearer ${getToken()}`;

  let res = await fetch(readUrl(`/component`), {
    method: "POST",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(componentData),
  });

  res = await parseJSON(res);

  return res.success;
};

export const updateComponent = async (componentId, componentData) => {
  const auth = `Bearer ${getToken()}`;

  try {
    let res = await fetch(readUrl(`/component/${componentId}`), {
      method: "PATCH",
      headers: {
        Accept: "application/json",
        Authorization: auth,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(componentData),
    });

    res = await parseJSON(res);

    return res.success;
  } catch (error) {
    return error;
  }
};

export const deleteComponent = async (id) => {
  const auth = `Bearer ${getToken()}`;

  let res = await fetch(readUrl(`/component/${id}`), {
    method: "DELETE",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
  });

  res = await parseJSON(res);

  return res.success;
};

// CATEGORIES

export const createCategory = async (categoryData) => {
  const auth = `Bearer ${getToken()}`;

  let res = await fetch(readUrlSimple(`/labCategory`), {
    method: "POST",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(categoryData),
  });

  res = await parseJSON(res);

  return res.success;
};

export const updateCategory = async (categoryId, categoryData) => {
  const auth = `Bearer ${getToken()}`;

  let res = await fetch(readUrlSimple(`/labCategory/${categoryId}`), {
    method: "PATCH",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(categoryData),
  });

  res = await parseJSON(res);

  return res.success;
};

export const deleteCategory = async (id) => {
  const auth = `Bearer ${getToken()}`;

  let res = await fetch(readUrlSimple(`/labCategory/${id}`), {
    method: "DELETE",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
  });

  res = await parseJSON(res);

  return res.success;
};

// LEVELS

export const createLevel = async (levelData) => {
  const auth = `Bearer ${getToken()}`;

  let res = await fetch(readUrlSimple(`/labLevel`), {
    method: "POST",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(levelData),
  });

  res = await parseJSON(res);

  return res.success;
};

export const updateLevel = async (levelId, levelData) => {
  const auth = `Bearer ${getToken()}`;

  let res = await fetch(readUrlSimple(`/labLevel/${levelId}`), {
    method: "PATCH",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(levelData),
  });

  res = await parseJSON(res);

  return res.success;
};

export const deleteLevel = async (id) => {
  const auth = `Bearer ${getToken()}`;

  let res = await fetch(readUrlSimple(`/labLevel/${id}`), {
    method: "DELETE",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
  });

  res = await parseJSON(res);

  return res.success;
};

// QUIZS

export const createQuiz = async (componentId) => {
  const auth = `Bearer ${getToken()}`;

  try {
    let res = await fetch(readUrlSimple(`/labQuiz`), {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: auth,
        "Content-Type": "application/json",
      },

      body: JSON.stringify({
        component_id: componentId,
      }),
    });

    res = await parseJSON(res);

    return res.success;
  } catch (error) {
    return error;
  }
};

// QUESTIONS

export const createQuestion = async (questionData) => {
  const auth = `Bearer ${getToken()}`;

  try {
    let res = await fetch(readUrlSimple(`/labQuiz/question`), {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: auth,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(questionData),
    });

    res = await parseJSON(res);

    return res.success;
  } catch (error) {
    return error;
  }
};

export const updateQuestion = async (questionId, questionData) => {
  const auth = `Bearer ${getToken()}`;

  try {
    let res = await fetch(readUrlSimple(`/labQuiz/question/${questionId}`), {
      method: "PATCH",
      headers: {
        Accept: "application/json",
        Authorization: auth,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(questionData),
    });

    res = await parseJSON(res);

    return res.success;
  } catch (error) {
    return error;
  }
};

export const deleteQuestion = async (id) => {
  const auth = `Bearer ${getToken()}`;

  try {
    let res = await fetch(readUrlSimple(`/labQuiz/question/${id}`), {
      method: "DELETE",
      headers: {
        Accept: "application/json",
        Authorization: auth,
        "Content-Type": "application/json",
      },
    });

    res = await parseJSON(res);

    return res.success;
  } catch (error) {
    return error;
  }
};

// OPTIONS

export const createOption = async (optionData) => {
  const auth = `Bearer ${getToken()}`;
  try {
    let res = await fetch(readUrlSimple(`/labQuiz/option`), {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: auth,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(optionData),
    });

    res = await parseJSON(res);

    return res.success;
  } catch (error) {
    return error;
  }
};

export const updateOption = async (optionId, optionData) => {
  const auth = `Bearer ${getToken()}`;

  try {
    let res = await fetch(readUrlSimple(`/labQuiz/option/${optionId}`), {
      method: "PATCH",
      headers: {
        Accept: "application/json",
        Authorization: auth,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(optionData),
    });

    res = await parseJSON(res);

    return res.success;
  } catch (error) {
    return error;
  }
};

export const deleteOption = async (id) => {
  const auth = `Bearer ${getToken()}`;

  try {
    let res = await fetch(readUrlSimple(`/labQuiz/option/${id}`), {
      method: "DELETE",
      headers: {
        Accept: "application/json",
        Authorization: auth,
        "Content-Type": "application/json",
      },
    });

    res = await parseJSON(res);

    return res.success;
  } catch (error) {
    return error;
  }
};

// SEGMENTATION

export const getSubclientesByClientId = async (id) => {
  const auth = `Bearer ${getToken()}`;

  let res = await fetch(readUrlSimple(`/labCliente/subclients/${id}`), {
    method: "GET",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
  });

  res = await parseJSON(res);

  return res.success;
};

// GROUPS CLIENTS

export const createClientGroup = async (data) => {
  const auth = `Bearer ${getToken()}`;

  let res = await fetch(readUrlSimple(`/labCliente`), {
    method: "POST",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  });

  res = await parseJSON(res);

  return res.success;
};

export const updateClientGroup = async (id, data) => {
  const auth = `Bearer ${getToken()}`;

  let res = await fetch(readUrlSimple(`/labCliente/${id}`), {
    method: "PATCH",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  });

  res = await parseJSON(res);

  return res.success;
};

export const deleteClientGroup = async (id) => {
  const auth = `Bearer ${getToken()}`;

  let res = await fetch(readUrlSimple(`/labCliente/${id}`), {
    method: "DELETE",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
  });

  res = await parseJSON(res);

  return res.success;
};

export const getClientGroups = async () => {
  const auth = `Bearer ${getToken()}`;

  let res = await fetch(readUrlSimple(`/labCliente`), {
    method: "GET",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
  });

  res = await parseJSON(res);

  return res.success;
};

// GROUP SECTORS

export const createSectorGroup = async (data) => {
  const auth = `Bearer ${getToken()}`;

  let res = await fetch(readUrlSimple(`/labSector`), {
    method: "POST",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  });

  res = await parseJSON(res);

  return res.success;
};

export const updateSectorGroup = async (id, data) => {
  const auth = `Bearer ${getToken()}`;

  let res = await fetch(readUrlSimple(`/labSector/${id}`), {
    method: "PATCH",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  });

  res = await parseJSON(res);

  return res.success;
};

export const deleteSectorGroup = async (id) => {
  const auth = `Bearer ${getToken()}`;

  let res = await fetch(readUrlSimple(`/labSector/${id}`), {
    method: "DELETE",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
  });

  res = await parseJSON(res);

  return res.success;
};

export const getSectorGroups = async () => {
  const auth = `Bearer ${getToken()}`;

  let res = await fetch(readUrlSimple(`/labSector`), {
    method: "GET",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
  });

  res = await parseJSON(res);

  return res.success;
};

// ASSOCIATED SECTORS

export const getAssociatedGroups = async () => {
  const auth = `Bearer ${getToken()}`;

  let res = await fetch(readUrlSimple(`/labAsociado`), {
    method: "GET",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
  });

  res = await parseJSON(res);

  return res.success;
};

export const getAssociatedList = async (params) => {
  const query = params ? new URLSearchParams(params) : null;
  const auth = `Bearer ${getToken()}`;

  let res = await fetch(readUrlSimple(`/labAsociado/list?${query && query.toString()}`), {
    method: "GET",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
  });

  res = await parseJSON(res);

  return res.success;
};

export const createAssociatedGroup = async (data) => {
  const auth = `Bearer ${getToken()}`;

  let res = await fetch(readUrlSimple(`/labAsociado`), {
    method: "POST",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  });

  res = await parseJSON(res);

  return res.success;
};

export const updateAssociatedGroup = async (id, data) => {
  const auth = `Bearer ${getToken()}`;

  let res = await fetch(readUrlSimple(`/labAsociado/${id}`), {
    method: "PATCH",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  });

  res = await parseJSON(res);

  return res.success;
};

export const deleteAssociatedGroup = async (id) => {
  const auth = `Bearer ${getToken()}`;

  let res = await fetch(readUrlSimple(`/labAsociado/${id}`), {
    method: "DELETE",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
  });

  res = await parseJSON(res);

  return res.success;
};

// EXPORT COURSES

export const exportCourses = async (params) => {
  const auth = `Bearer ${getToken()}`;

  const query = new URLSearchParams(params);

  // Eliminar el parámetro 'page'
  query.delete("page");

  let res = await fetch(readUrl(`/courses/csv?${query.toString()}`), {
    method: "GET",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
  });

  res = await parseText(res);

  return res.text;
};

export const exportCourseById = async (id) => {
  const auth = `Bearer ${getToken()}`;
  let res = await fetch(readUrl(`/courses/enrollments/csv/${id}`), {
    method: "GET",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
  });

  res = await parseText(res);

  return res.text;
};
